<nb-card class="asset-type-selector-page-card">
  <nb-card-header class="header">
    <h3 class="title">{{ "Technical nomenclature" | translate }}</h3>
    <button class="close-btn" (click)="close()">
      <i class="fa-light fa-x"></i>
    </button>
  </nb-card-header>
  <nb-card-body class="body">
    <app-asset-type-selector
      [editMode]="true"
      [searchMode]="searchMode"
      [parent]="parent"
      [autoSelectAssetTypeId]="autoSelectAssetTypeId"
      [autoSelectSubCategoryId]="autoSelectSubCategoryId"
      [autoSelectCategoryId]="autoSelectCategoryId"
      [preventAssetTypesThatNeedParent]="preventAssetTypesThatNeedParent"
      (assetTypeSelected)="onAssetTypeSelected($event)">
    </app-asset-type-selector>
  </nb-card-body>
</nb-card>

